import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  preferencesContainer: {
    padding: 20,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up('sm')]: {
      width: 500,
    },
    [theme.breakpoints.down('sm')]: {
      width: "100%",
    },
  },
  bottomMargin: {
    marginBottom: theme.spacing(1)
  },
  tierLabel: {
    fontWeight: 600,
    minWidth: 50
  },
  defaultInput: {
    backgroundColor: theme.palette.background.level2
  },
  flexCenter: {
    display: "flex",
    alignItems: "center"
  },
  sectionWrapper: {
    marginTop: 20
  },
  sectionDivider: {
    marginBottom: 15
  },
  defaultColorsBtn: {
    marginTop: 8,
    textTransform: "uppercase",
    fontWeight: 600
  },
  contentArea: {
    flex: 1
  },
  btnGroup: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    padding: theme.spacing(2)
  }
}));